import { cn } from "@/lib/utils";

/**
 * THE ADAM logosu (beyaz, saydam zemin). "onDark": koyu zeminde olduğu gibi;
 * "auto": açık temada koyulaştırılır, koyu temada beyaz kalır.
 */
export function TheAdamMark({ className, tone = "auto" }: { className?: string; tone?: "onDark" | "auto" }) {
  return (
    <img
      src="/brand-theadam.png"
      alt="THE ADAM"
      width={1024}
      height={173}
      className={cn("h-6 w-auto select-none", tone === "auto" && "brightness-0 dark:brightness-100", className)}
      draggable={false}
    />
  );
}

/**
 * Kadri Yakışıklı Saat logosu (koyu, saydam zemin). "onDark": beyaza çevrilir;
 * "auto": açık temada olduğu gibi, koyu temada beyaz.
 */
export function StoreLogo({ className, tone = "auto" }: { className?: string; tone?: "onDark" | "auto" }) {
  return (
    <img
      src="/brand-kadriyakisikli.webp"
      alt="Kadri Yakışıklı Saat"
      width={500}
      height={200}
      className={cn("h-12 w-auto select-none", tone === "onDark" ? "brightness-0 invert" : "dark:brightness-0 dark:invert", className)}
      draggable={false}
    />
  );
}
